import config from '../../../../config';

const getComponentsPanelSchema = (components) => {
  const schema = {
    title: {
      type: 'string',
      default: 'Components',
    },
    options: {
      type: 'object',
      properties: {
        ...(!config?.onPremise && {
          allowFloat: {
            type: 'boolean',
            title: 'Allow floating',
            default: false,
          },
        }),
        withToolbar: {
          type: 'boolean',
          title: 'Include panel tools',
          default: false,
        },
        displayStatus: {
          type: 'boolean',
          title: 'Show component status',
          default: false,
        },
        ...(!config?.onPremise && {
          autoLoad: {
            type: 'boolean',
            title: 'Load model on selection',
            default: false,
          },
        }),
        flatList: {
          type: 'boolean',
          title: 'Show as flat list',
          default: false,
        },
        showVirtuals: {
          type: 'boolean',
          title: 'Show virtual type components',
          default: true,
        },
        startingDepth: {
          type: 'number',
          title: 'Starting depth (site = 1)',
          minimum: 1,
          placeholder: 1,
          default: 1,
        },
        endingDepth: {
          type: 'number',
          title: 'Ending depth (no limit = 0)',
          minimum: 0,
          placeholder: 0,
          default: 0,
        },
        expanded: {
          type: 'boolean',
          title: 'Expand all first descendant components by default',
          default: true,
        },
      },
    },
  };

  if (components.length > 0) {
    const componentOptions = {
      type: 'string',
      anyOf: components.map((c) => ({
        enum: [c.id],
        title:
          c.itemDesignation === '-'
            ? `${c.name}`
            : `[${c.itemDesignation.replace('=', '')}] ${c.name}`,
      })),
    };

    schema.options.properties.limitComponents = {
      type: 'array',
      title: 'Limit to specific components.',
      default: [],
      uniqueItems: true,
      isMulti: true,
      items: componentOptions,
    };

    schema.options.properties.excludeComponents = {
      type: 'array',
      title: 'Exclude specific components.',
      default: [],
      uniqueItems: true,
      isMulti: true,
      items: componentOptions,
    };
  }

  return schema;
};

export default getComponentsPanelSchema;
